
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_container_remote_(ttm(MaintenanceToggle|OrdersQuery)_Module|derivative(\-risk\-rates|s\-pricing)_Module|ccv\-co(mparis|ntract\-classificati)on_Module|(general\-contracting\-conditions|home|national\-cash\-request)_Module)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
